// next-app/src/providers/index.tsx
'use client';

import type { ReactNode } from 'react';
import { AuthProvider } from './auth-provider';
import { QueryProvider } from './query-provider';
import { SeasonProvider } from './season-provider';
import { ErrorBoundary } from './error-boundary';

interface ProvidersProps {
  children: ReactNode;
}

export function Providers({ children }: ProvidersProps) {
  return (
    <ErrorBoundary>
      <QueryProvider>
        <SeasonProvider>
          <AuthProvider>{children}</AuthProvider>
        </SeasonProvider>
      </QueryProvider>
    </ErrorBoundary>
  );
}

// Re-export hooks for convenience
export { useRequireAuth, useRedirectIfAuthenticated } from './auth-provider';

// Re-export error reporting utilities
export { reportError, setErrorUser, clearErrorUser } from './error-boundary';
